import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { AUTH0_API_AUDIENCE } from "./utils/sessionAccessToken";

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = "priorityone.au.auth0.com";
  const clientId = "5PIZpCNvhphXrnmhGck5Jbk6dRBMiMrz";
  const redirectUri = window.location.origin;
  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: AUTH0_API_AUDIENCE,
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
